import React, {useEffect, useState} from "react";
import { Alert, Grid } from "@mui/material";
import ConfigFields from "./components/patterns/ConfigFields/ConfigFields";
import { AnswerFields } from "./components/patterns/AnswerFields";
import {useFormContext} from "react-hook-form";
import {QuestionTypes} from "../../../static/enums/Questions";

export interface ChoiceTextMultipleProps {
    prefix?: string;
}

export default function ChoiceTextMultiple({ prefix }: ChoiceTextMultipleProps) {
    const { formState, setValue, resetField } = useFormContext();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (formState.dirtyFields[`${prefix}class`]) {
            setValue(`${prefix}correct_answer`, [])
            setValue(`${prefix}answer_config`, [])
            resetField(`${prefix}class`, {
                keepDirty: true,
                defaultValue: QuestionTypes.choice_text_multiple
            })
        }
        setLoading(false);
    }, [])

    return (
        loading
        ? null
        :    (
            <Grid container direction={"column"} sx={theme => ({ padding: theme.spacing(1, 0) })}>
                <Alert severity="info" sx={theme => ({ margin: theme.spacing(2, 0) })}>
                    Выбор нескольких текстовых/TeX вариантов: Верные ответы вводятся в поля цифрами через запятую
                </Alert>
                <ConfigFields prefix={prefix}/>
                <AnswerFields prefix={prefix}/>
            </Grid>
        )
    );
}